/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
import { PublicAPIImpl } from './PublicAPI'

// Note that email or sub is considered the users's ID
export interface SecondaryCustomer {
  id: number;
}

export interface AddRemovePatch {
  add?: Array<string>;
  remove?: Array<string>;
}

export interface UserGroup {
  id: number;
  roles: Array<string>;
}

export interface NewUser extends Record<string, string | Array<string> | boolean | number | SecondaryCustomer | Array<UserGroup> | null | undefined> {
  customer_id?: number | null;
  email?: string;
  family_name: string;
  given_name: string;
  locale?: string;
  phone_number?: string;
  phone_number_verified?: boolean;
  enabled?: boolean;
  send_email?: boolean;
  internal: boolean;
  zoneinfo?: string;
  groups?: Array<UserGroup>;
  secondary_customer_1?: SecondaryCustomer | null;
  secondary_customer_2?: SecondaryCustomer | null;
  secondary_customer_3?: SecondaryCustomer | null;
  secondary_customer_4?: SecondaryCustomer | null;
  secondary_customer_5?: SecondaryCustomer | null;
  secondary_customer_6?: SecondaryCustomer | null;
  secondary_customer_7?: SecondaryCustomer | null;
  secondary_customer_8?: SecondaryCustomer | null;
  secondary_customer_9?: SecondaryCustomer | null;
}

export interface User extends NewUser {
  created_utc: string; // "2021-03-22T08:42:46",
  email_verified: boolean;
  modified_utc: string; // "2021-03-22T08:42:48",
  status: string; // "CONFIRMED", may need to be enum?
  sub: string;
  activated: boolean;
  template?: {
    default: boolean;
    id: number;
  };
  roles?: Array<string>;
}

export interface NewCustomer {
  name: string;
  other_ids?: {tokara?: string, alldayrtk?: string} | Record<string, string | null> | null,
  abn?: string | null;
  nav_id?: string;
  parent_id?: number | null;
}

export interface Customer extends NewCustomer {
  created_utc: string; // "2021-03-22T08:42:46",
  deleted_utc?: string; // "2021-03-22T08:42:46",
  id: number;
}

export interface RolesUpdate {
  roles: {
    primary?: Array<string>,
    secondary_1?: Array<string>,
    secondary_2?: Array<string>,
    secondary_3?: Array<string>,
    secondary_4?: Array<string>,
    secondary_5?: Array<string>,
    secondary_6?: Array<string>,
    secondary_7?: Array<string>,
    secondary_8?: Array<string>,
    secondary_9?: Array<string>
  } | null | Record<string, Array<string> | undefined>;
}

export interface RolesPatch extends Record<string, AddRemovePatch | undefined> {
  primary?: AddRemovePatch;
  secondary_1?: AddRemovePatch;
  secondary_2?: AddRemovePatch;
  secondary_3?: AddRemovePatch;
  secondary_4?: AddRemovePatch;
  secondary_5?: AddRemovePatch;
  secondary_6?: AddRemovePatch;
  secondary_7?: AddRemovePatch;
  secondary_8?: AddRemovePatch;
  secondary_9?: AddRemovePatch;
}

export interface NewGroup {
  name: string;
  description?: string | null;
  owner_customer_id?: number;
  role_templates?: Array<number>;
  other_ids?: {tokara?: Array<string>, alldayrtk?: Array<string>} | Record<string, Array<string> | null> | null,
}

export interface GroupPatch {
  name?: string;
  description?: string | null;
  owner_customer_id?: number;
  role_templates?: Array<number>;
  other_ids?: {tokara?: AddRemovePatch, alldayrtk?: AddRemovePatch} | Record<string, AddRemovePatch | undefined> | null,
}

export interface Group extends NewGroup {
  id: number;
  grouped_groups: Array<number>;
  created_utc: string; // "2021-03-22T08:42:46"
  deleted_utc?: string; // "2021-03-22T08:42:46"
}

export interface NewGroupCollection {
  name: string;
  description: string;
  groups: Array<number>;
}

export interface GroupCollection extends NewGroupCollection {
  id: number;
  created_utc: string; // "2021-03-22T08:42:46"
  deleted_utc?: string; // "2021-03-22T08:42:46"
}

export interface Position {
  id: number | null;
  lat: string | null; // ex: 27.584198S
  lon: string | null; // ex: 151.925126E
  rssi: number | null;
  time_received_utc: string | null; // ex: Wed, 27 Sep 2017 22:10:18 GMT
  fix: string | null;
}

export interface Subscription {
  application: string | null; // Maybe enum?
  start_utc: string; // "YYYY-MM-DD"
  type: string;
  valid_to_utc: string; // "YYYY-MM-DD"
}

export interface VPNUserHardware {
  controlboxMAC: string | null;
  controlboxSerial: string | null;
  gpsBRD: string | null;
  gpsFW: string | null;
  gpsHW: string | null;
  gpsRCV: string | null;
  gpsSN: string | null;
  auxBRD: string | null;
  auxFW: string | null;
  auxHW: string | null;
  auxRCV: string | null;
  auxSN: string | null;
}

export interface TokaraVPNUser {
  access_level: string;
  alias: string | null;
  common_name?: string;
  connected: boolean;
  connected_to_proxy: boolean;
  dns_name?: string;
  hardware: VPNUserHardware | null;
  id: number;
  ip: string;
  last_seen_utc: string; // ex: Sat, 11 Feb 2017 21:05:42 GMT
  last_seen_via: string; // Maybe enum? "vpn", "proxy", "both"
  latest_position: Position | null;
  machine_type: string | null;
  subscription: Subscription | null;
  subscription_application?: string;
  machine_access?: string;
  user_enabled: boolean;
}

export interface TokaraCustomer {
  vpnusers: Array<TokaraVPNUser>;
  state: string;
  id: number;
  name: string;
}

export interface RoleTemplate {
  id: number;
  name: string;
  roles: Array<string>;
}

export interface NewSSORoleTemplate {
  name: string;
  description: string;
  roles: Array<string>;
}

export interface SSORoleTemplate extends NewSSORoleTemplate {
  id: number;
  created_utc: string;
  deleted_utc?: string;
}

export interface SystemTemplate {
  id?: number;
  name: string;
  description: string;
  domains?: Array<string>;
  domains_regex?: Array<string>;
  roles: Array<string>;
  num_users?: number;
  created_utc?: string;
  deleted_utc?: string;
}

export interface SystemDefaultTemplate {
  roles: Array<string>;
  num_users: number;
}

export interface SystemTemplatePatch {
  name?: string;
  description?: string;
  domains?: AddRemovePatch;
  domains_regex?: AddRemovePatch;
  roles?: AddRemovePatch;
}

export interface SystemRole {
  name: string;
  description?: string;
}

export interface GroupUserRole {
  sub: string;
  roles: Array<string>;
}

export interface SimpleResponse {
  status?: string;
  error_code?: string;
  error_detail?: string;
}

export interface UsersResponse extends SimpleResponse {
  next_page_token: string;
  users: Array<User>;
}

export interface CustomersResponse extends SimpleResponse {
  next_page_token: string;
  customers: Array<Customer>;
}

export interface GroupsResponse extends SimpleResponse {
  next_page_token: string;
  groups: Array<Group>;
}

export interface GroupsUserRolesResponse extends SimpleResponse {
  next_page_token: string;
  users: Array<GroupUserRole>;
}

export interface GroupCollectionsResponse extends SimpleResponse {
  next_page_token: string;
  group_collections: Array<GroupCollection>;
}

export interface SSORoleTemplatesResponse extends SimpleResponse {
  next_page_token: string;
  role_templates: Array<SSORoleTemplate>;
}

export interface CustomerResponse extends SimpleResponse {
  customer: Customer;
}

export interface UserResponse extends SimpleResponse {
  user: User;
}

export interface RolesResponse extends SimpleResponse {
  roles: {
    primary?: Array<string>,
    secondary_customer_1?: Array<string>,
    secondary_customer_2?: Array<string>,
    secondary_customer_3?: Array<string>,
    secondary_customer_4?: Array<string>,
    secondary_customer_5?: Array<string>,
    secondary_customer_6?: Array<string>,
    secondary_customer_7?: Array<string>,
    secondary_customer_8?: Array<string>,
    secondary_customer_9?: Array<string>
  } | null | Record<string, Array<string> | undefined>;
}

export interface RoleTemplateResponse extends SimpleResponse {
  templates: Array<RoleTemplate>;
}

export interface GroupResponse extends SimpleResponse {
  groups: Array<UserGroup>;
}

export interface SystemTemplateResponse extends SimpleResponse {
  next_page_token: string;
  templates: Array<SystemTemplate>;
}

export interface SystemDefaultTemplateResponse extends SimpleResponse {
  default_template: SystemDefaultTemplate;
}

export interface SystemDefaultTemplateUsersResponse extends SimpleResponse {
  default_template: { users: Array<string> };
}

export interface SystemTemplateUsersResponse extends SimpleResponse {
  template: { users: Array<string> };
}

export interface SystemRolesResponse extends SimpleResponse {
  roles: Array<SystemRole>;
}

export interface TokaraCustomersResponse extends SimpleResponse {
  data: { customers: Array<TokaraCustomer> }
}

export class APIImpl extends PublicAPIImpl {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addCurrentDataPatch (val: any, current?: any) {
    if (current) {
      val.__current = current
    }
    return JSON.stringify(val)
  }

  getAdminUsers (pageToken?: string) {
    return this.getParams<UsersResponse>('/admin/users', pageToken ? { page_token: pageToken } : null)
  }

  postAdminUsers (val: NewUser) {
    return this.post<UserResponse>('/admin/users', JSON.stringify(val))
  }

  patchAdminUsers (cid: string, val: NewUser, current?: NewUser) {
    return this.patch<SimpleResponse>('/admin/users/' + cid, this.addCurrentDataPatch(val, current))
  }

  deleteAdminUsers (cid: string) {
    return this.delete<SimpleResponse>('/admin/users/' + cid)
  }

  getAdminUserRoles (cid: string) {
    return this.get<RolesResponse>('/admin/users/' + cid + '/roles')
  }

  putAdminUserRoles (cid: string, val: RolesUpdate) {
    return this.put<SimpleResponse>('/admin/users/' + cid + '/roles', JSON.stringify(val))
  }

  patchAdminUserRoles (cid: string, val: RolesPatch) {
    return this.patch<SimpleResponse>('/admin/users/' + cid + '/roles', JSON.stringify(val))
  }

  getAdminUserGroups (cid: string) {
    return this.get<GroupResponse>('/admin/users/' + cid + '/groups')
  }

  postAdminUserGroups (cid: string, val: UserGroup) {
    return this.post<SimpleResponse>('/admin/users/' + cid + '/groups', JSON.stringify(val))
  }

  patchAdminUserGroups (cid: string, groupId: number, val: AddRemovePatch) {
    return this.patch<SimpleResponse>('/admin/users/' + cid + '/groups/' + groupId, JSON.stringify(val))
  }

  deleteAdminUserGroups (cid: string, gid: number) {
    return this.delete<SimpleResponse>('/admin/users/' + cid + '/groups/' + gid.toString())
  }

  postAdminUserEnable (cid: string) {
    return this.post<SimpleResponse>('/admin/users/' + cid + '/enable', '')
  }

  postAdminUserDisable (cid: string) {
    return this.post<SimpleResponse>('/admin/users/' + cid + '/disable', '')
  }

  postAdminUserResendCode (cid: string) {
    return this.post<SimpleResponse>('/admin/users/' + cid + '/resend-code', JSON.stringify({ type: 'email' }))
  }

  postAdminUserManualValidation (cid: string) {
    return this.post<SimpleResponse>('/admin/users/' + cid + '/manual-validation', JSON.stringify({ type: 'email' }))
  }

  postAdminUserPassword (cid: string, pw: string, forceChange?: boolean) {
    return this.post<SimpleResponse>('/admin/users/' + cid + '/password', JSON.stringify({ password: pw, force_change: forceChange }))
  }

  getAdminCustomers (pageToken?: string) {
    return this.getParams<CustomersResponse>('/admin/customers', pageToken ? { page_token: pageToken } : null)
  }

  postAdminCustomers (val: NewCustomer) {
    return this.post<CustomerResponse>('/admin/customers', JSON.stringify(val))
  }

  patchAdminCustomers (cid: number, val: NewCustomer, current?: NewCustomer) {
    return this.patch<SimpleResponse>('/admin/customers/' + cid, this.addCurrentDataPatch(val, current))
  }

  deleteAdminCustomers (cid: number) {
    return this.delete<SimpleResponse>('/admin/customers/' + cid)
  }

  getAdminTemplates (pageToken?: string) {
    return this.getParams<SystemTemplateResponse>('/admin/templates', pageToken ? { page_token: pageToken } : null)
  }

  postAdminTemplates (val: SystemTemplate) {
    return this.post<CustomerResponse>('/admin/templates', JSON.stringify(val))
  }

  patchAdminTemplates (cid: number, val: SystemTemplatePatch) {
    return this.patch<SimpleResponse>('/admin/templates/' + cid, JSON.stringify(val))
  }

  deleteAdminTemplates (cid: number) {
    return this.delete<SimpleResponse>('/admin/templates/' + cid)
  }

  getAdminTemplatesUsers (cid: number) {
    return this.get<SystemTemplateUsersResponse>('/admin/templates/' + cid + '/users')
  }

  getAdminTemplatesDefault () {
    return this.get<SystemDefaultTemplateResponse>('/admin/templates/default')
  }

  patchAdminTemplatesDefault (val: SystemTemplatePatch) {
    return this.patch<SimpleResponse>('/admin/templates/default', JSON.stringify(val))
  }

  getAdminTemplatesDefaultUsers () {
    return this.get<SystemDefaultTemplateUsersResponse>('/admin/templates/default/users')
  }

  getAdminRoles () {
    return this.get<SystemRolesResponse>('/admin/roles')
  }

  postTemplate (rt: RoleTemplate) {
    return this.post<SimpleResponse>('/templates', JSON.stringify(rt))
  }

  putTemplate (rt: RoleTemplate) {
    return this.put<SimpleResponse>('/templates', JSON.stringify(rt))
  }

  getTemplates () {
    return this.get<RoleTemplateResponse>('/templates')
  }

  deleteTemplate (rtId: number) {
    return this.delete<SimpleResponse>('/templates?id=' + rtId)
  }

  getUser () {
    return this.get<UserResponse>('/user')
  }

  patchUser (val: NewUser, current?: NewUser) {
    return this.patch<SimpleResponse>('/user', this.addCurrentDataPatch(val, current))
  }

  getCustomer (customerId: number) {
    return this.get<CustomerResponse>('/customer/' + customerId)
  }

  getTokaraCustomers () {
    return this.get<TokaraCustomersResponse>('/tokara')
  }

  getAdminGroups (pageToken?: string) {
    return this.getParams<GroupsResponse>('/admin/groups', pageToken ? { page_token: pageToken } : null)
  }

  getAdminGroupUserss (gid: number, pageToken?: string) {
    return this.getParams<GroupsUserRolesResponse>('/admin/groups/' + gid + '/users', pageToken ? { page_token: pageToken } : null)
  }

  postAdminGroups (val: NewGroup) {
    return this.post<GroupResponse>('/admin/groups', JSON.stringify(val))
  }

  patchAdminGroups (cid: number, val: GroupPatch, current?: NewGroup) {
    return this.patch<SimpleResponse>('/admin/groups/' + cid, this.addCurrentDataPatch(val, current))
  }

  deleteAdminGroups (cid: number) {
    return this.delete<SimpleResponse>('/admin/groups/' + cid)
  }

  getAdminSSORoleTemplates (pageToken?: string) {
    return this.getParams<SSORoleTemplatesResponse>('/admin/role-templates', pageToken ? { page_token: pageToken } : null)
  }

  getAdminGroupCollections (pageToken?: string) {
    return this.getParams<GroupCollectionsResponse>('/admin/group-collections', pageToken ? { page_token: pageToken } : null)
  }
}

const API = new APIImpl()

export default API
